import {useApiRemove} from "../../../../../lib/HttpService";
import {PATH} from "./const";
import { StubbornRouter } from "../../../../../application/business/StubbornRouter";

export const useEditionRouterRemove = () => useApiRemove<StubbornRouter>(PATH);
